Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _includes2=require("lodash/includes");var _includes3=_interopRequireDefault(_includes2);
var _helpers=require("./helpers");var _helpers2=_interopRequireDefault(_helpers);
var _collection=require("./collection");var _collection2=_interopRequireDefault(_collection);
var _d3Scale=require("d3-scale");var d3Scale=_interopRequireWildcard(_d3Scale);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var supportedScaleStrings=["linear","time","log","sqrt"];exports.default=

{

getDefaultScale:function getDefaultScale(){
return d3Scale.scaleLinear();
},

toNewName:function toNewName(scale){

var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
return"scale"+capitalize(scale);
},

validScale:function validScale(scale){
if(typeof scale==="function"){
return(0,_isFunction3.default)(scale.copy)&&(0,_isFunction3.default)(scale.domain)&&(0,_isFunction3.default)(scale.range);
}else if(typeof scale==="string"){
return(0,_includes3.default)(supportedScaleStrings,scale);
}
return false;
},

isScaleDefined:function isScaleDefined(props,axis){
if(!props.scale){
return false;
}else if(props.scale.x||props.scale.y){
return props.scale[axis]?true:false;
}
return true;
},

getScaleTypeFromProps:function getScaleTypeFromProps(props,axis){
if(!this.isScaleDefined(props,axis)){
return undefined;
}
var scale=props.scale[axis]||props.scale;
return typeof scale==="string"?scale:this.getType(scale);
},

getScaleFromProps:function getScaleFromProps(props,axis){
if(!this.isScaleDefined(props,axis)){
return undefined;
}
var scale=props.scale[axis]||props.scale;

if(this.validScale(scale)){
return(0,_isFunction3.default)(scale)?scale:d3Scale[this.toNewName(scale)]();
}
},

getScaleTypeFromData:function getScaleTypeFromData(props,axis){
if(!props.data){
return"linear";
}
var accessor=_helpers2.default.createAccessor(props[axis]);
var axisData=props.data.map(accessor);
return _collection2.default.containsDates(axisData)?"time":"linear";
},

getBaseScale:function getBaseScale(props,axis){
var scale=this.getScaleFromProps(props,axis);
if(scale){
return scale;
}
var dataScale=this.getScaleTypeFromData(props,axis);
return d3Scale[this.toNewName(dataScale)]();
},

getType:function getType(scale){
var duckTypes=[
{name:"log",method:"base"},
{name:"ordinal",method:"unknown"},
{name:"pow-sqrt",method:"exponent"},
{name:"quantile",method:"quantiles"},
{name:"quantize-threshold",method:"invertExtent"}];

var scaleType=duckTypes.filter(function(type){
return scale[type.method]!==undefined;
})[0];
return scaleType?scaleType.name:undefined;
},

getScaleType:function getScaleType(props,axis){

return this.getScaleTypeFromProps(props,axis)||this.getScaleTypeFromData(props,axis);
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-util/scale.js
// module id = 265
// module chunks = 0 1